import produce from 'immer';
import {
  GET_STORE_STATISTICS_START,
  GET_STORE_STATISTICS_SUCCESS,
  GET_STORE_STATISTICS_FAILED,
  GET_SM_BANNERS_START,
  GET_SM_BANNERS_SUCCESS,
  GET_SM_BANNERS_FAILED,
  CREATE_SM_BANNER_START,
  CREATE_SM_BANNER_SUCCESS,
  CREATE_SM_BANNER_FAILED,
  UPDATE_SM_BANNER_START,
  UPDATE_SM_BANNER_SUCCESS,
  UPDATE_SM_BANNER_FAILED,
  DELETE_SM_BANNER_START,
  DELETE_SM_BANNER_SUCCESS,
  DELETE_SM_BANNER_FAILED,
  SEND_REQUEST_INFORMATION_EMAIL_START,
  SEND_REQUEST_INFORMATION_EMAIL_SUCCESS,
  SEND_REQUEST_INFORMATION_EMAIL_FAILED,
  GET_FUTURE_ASSIGNED_TASKS_START,
  GET_FUTURE_ASSIGNED_TASKS_SUCCESS,
  GET_FUTURE_ASSIGNED_TASKS_FAILED,
} from '../actions/home';


const initialState = {
  storeStatistic: {
    customers_count: 0,
    orders_count: 0,
    life_time_sales: 0,
    average_sales: 0,
    bestsellers: [],
    last_orders: []
  },
  smBanners: [],
  futureAssignedTasks: [],
  error: false,
  isLoading: false,
  isSMBannersLoading: false,
  isSendingEmail: false
};

const formReducer = produce((state: IHomeState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_STATISTICS_START: {
      state.isLoading = true;
      break;
    }
    case GET_STORE_STATISTICS_SUCCESS: {
      const {data} = action;

      state.storeStatistic = data;
      state.isLoading = false;
      break;
    }
    case GET_STORE_STATISTICS_FAILED: {
      state.error = true;
      state.isLoading = false;
      break;
    }

    case GET_SM_BANNERS_START: {
      state.isSMBannersLoading = true;
      break;
    }
    case GET_SM_BANNERS_SUCCESS: {
      const {data} = action;

      state.smBanners = data;
      state.isSMBannersLoading = false;
      break;
    }
    case GET_SM_BANNERS_FAILED: {
      state.isSMBannersLoading = false;
      break;
    }

    case CREATE_SM_BANNER_START: {
      state.isSMBannersLoading = true;
      break;
    }
    case CREATE_SM_BANNER_SUCCESS: {
      const {banner} = action.data;
      state.smBanners = [...state.smBanners, banner];
      state.isSMBannersLoading = false;
      break;
    }
    case CREATE_SM_BANNER_FAILED: {
      state.isSMBannersLoading = false;
      break;
    }

    case UPDATE_SM_BANNER_START: {
      state.isSMBannersLoading = true;
      break;
    }
    case UPDATE_SM_BANNER_SUCCESS: {
      const {banner} = action.data;
      state.smBanners = state.smBanners.map((b) => b._id === banner._id ? banner : b);
      state.isSMBannersLoading = false;
      break;
    }
    case UPDATE_SM_BANNER_FAILED: {
      state.isSMBannersLoading = false;
      break;
    }

    case DELETE_SM_BANNER_START: {
      state.isSMBannersLoading = true;
      break;
    }
    case DELETE_SM_BANNER_SUCCESS: {
      const {id} = action;
      state.smBanners = state.smBanners.filter((b) => b._id !== id);
      state.isSMBannersLoading = false;
      break;
    }
    case DELETE_SM_BANNER_FAILED: {
      state.isSMBannersLoading = false;
      break;
    }

    case SEND_REQUEST_INFORMATION_EMAIL_START: {
      state.isSendingEmail = true;
      break;
    }
    case SEND_REQUEST_INFORMATION_EMAIL_SUCCESS: {
      state.isSendingEmail = false;
      break;
    }
    case SEND_REQUEST_INFORMATION_EMAIL_FAILED: {
      state.isSendingEmail = false;
      break;
    }

    case GET_FUTURE_ASSIGNED_TASKS_START: {
      state.isLoading = true;
      break;
    }
    case GET_FUTURE_ASSIGNED_TASKS_SUCCESS: {
      const {data} = action;
      state.futureAssignedTasks = data.tasks;
      state.isLoading = false;
      break;
    }
    case GET_FUTURE_ASSIGNED_TASKS_FAILED: {
      state.isLoading = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
